import { render, staticRenderFns } from "./CardRoomInfo.vue?vue&type=template&id=58d634a9&scoped=true"
import script from "./CardRoomInfo.vue?vue&type=script&lang=js"
export * from "./CardRoomInfo.vue?vue&type=script&lang=js"
import style0 from "./CardRoomInfo.vue?vue&type=style&index=0&id=58d634a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d634a9",
  null
  
)

export default component.exports